export default {
    SET_LOADER(state, payload) {
      state.loader = payload;
    },
}